import React from 'react';
import './MutantC60.css';


const BuildAgent = () => {

    return (
            <div className="Tutorial">
              <div className="tutorial-header">
                <h1>Creating New Agents</h1>
              </div>

                <div className="tutorial-content">
                    <section className="tutorial-section">
                        <h2>🕸️ You Can Create Your Own Tangled Agents</h2>
                        <p>
                            You can create your own Tangled agents! Building an agent to play Tangled is
                            straightforward. <a href={"https://github.com/snowdropquantum/snowdrop-tangled-agents"}>Here
                            is the repo you should start with</a> (it's also on pypi).
                        </p>
                    </section>
                </div>

            </div>
    );
};
export default BuildAgent;